enum BetTextKeys {
	// Bet display
	ID_LABEL = 'SPORTSBOOK_MY_BETS_ID_LABEL',
	TICKET_LOST_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_LOST_LABEL',
	TICKET_WON_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_WON_LABEL',
	TICKET_OPEN_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_OPEN_LABEL',
	TICKET_CASHED_OUT_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_CASHED_OUT_LABEL',
	TICKET_CANCELLED_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_CANCELLED_LABEL',
	TICKET_RETURNED_RISK_FREE_BET_LABEL = 'TICKET_RETURNED_RISK_FREE_BET_LABEL',
	TICKET_EVENT_CANCELLED_LABEL = 'TICKET_EVENT_CANCELLED_LABEL',
	TICKET_POSSIBLE_WIN_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_POSSIBLE_WIN_LABEL',
	TICKET_PLACED_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_PLACED_LABEL',
	TICKET_SETTLED_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_SETTLED_LABEL',
	TICKET_TITLE_COMBO_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_TITLE_COMBO_LABEL',
	TICKET_TITLE_SINGLE_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_TITLE_SINGLE_LABEL',
	TICKET_TITLE_SYSTEM_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_TITLE_SYSTEM_LABEL',
	TICKET_STAKE_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_STAKE_LABEL',
	TICKET_RISK_FREE_BET_STAKE_LABEL = 'SPORTSBOOK_MY_BETS_RISK_FREE_BET_STAKE_LABEL',
	TICKET_BET_BOOST_LABEL = 'TICKET_BET_BOOST_LABEL',
	TICKET_SUPER_BOOST_LABEL = 'TICKET_SUPER_BOOST_LABEL',
	TICKET_FREE_BET_STAKE_LABEL = 'SPORTSBOOK_MY_BETS_FREE_BET_STAKE_LABEL',
	// Cashout
	CASHOUT_BUTTON_LABEL = 'SPORTSBOOK_MY_BETS_CASHOUT_BUTTON_LABEL',
	CASHOUT_BUTTON_NEW_OFFER_CONFIRM = 'SPORTSBOOK_MY_BETS_CASHOUT_BUTTON_NEW_OFFER_CONFIRM',
	CASHOUT_BUTTON_NEW_OFFER_REJECT = 'SPORTSBOOK_MY_BETS_CASHOUT_BUTTON_NEW_OFFER_REJECT',
	CASHOUT_NEW_OFFER_MESSAGE = 'SPORTSBOOK_MY_BETS_CASHOUT_NEW_OFFER_MESSAGE',
	TICKET_CASHOUT_ERROR_MESSAGE = 'SPORTSBOOK_MY_BETS_TICKET_CASHOUT_ERROR_MESSAGE',
	CASHOUT_BUTTON_LABEL_CONFIRM = 'SPORTSBOOK_MY_BETS_CASHOUT_BUTTON_LABEL_CONFIRM',
	TICKET_CASHOUT_DIALOG_TITLE = 'SPORTSBOOK_MY_BETS_TICKET_CASHOUT_DIALOG_TITLE',
	TICKET_CASHOUT_DIALOG_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_CASHOUT_DIALOG_LABEL',
	TICKET_CASHOUT_DIALOG_BUTTON_LABEL = 'SPORTSBOOK_MY_BETS_TICKET_CASHOUT_DIALOG_BUTTON_LABEL',
	// Toggle share
	SHARE_BUTTON_LABEL = 'SPORTSBOOK_MY_BETS_SHARE_BUTTON_LABEL',
	SHARE_MODAL_HEADER_LABEL = 'SPORTSBOOK_MY_BETS_SHARE_MODAL_HEADER_LABEL',
	SHARE_MODAL_BUTTON_LABEL = 'SPORTSBOOK_MY_BETS_SHARE_MODAL_BUTTON_LABEL',
	SHARE_MODAL_BET = 'SPORTSBOOK_MY_BETS_SHARE_MODAL_BET',

	// Toggle show more
	SHOW_MORE_LABEL = 'SPORTSBOOK_MY_BETS_SHOW_MORE',
	SHOW_LESS_LABEL = 'SPORTSBOOK_MY_BETS_SHOW_LESS',

	// Bet info toggle
	BET_INFO_LABEL = 'SPORTSBOOK_MY_BETS_BET_INFO',

	// System bet combination textkeys
	SYSTEM_BET_COMBINATION_1_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_1_LABEL',
	SYSTEM_BET_COMBINATION_2_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_2_LABEL',
	SYSTEM_BET_COMBINATION_3_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_3_LABEL',
	SYSTEM_BET_COMBINATION_4_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_4_LABEL',
	SYSTEM_BET_COMBINATION_5_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_5_LABEL',
	SYSTEM_BET_COMBINATION_6_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_6_LABEL',
	SYSTEM_BET_COMBINATION_7_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_7_LABEL',
	SYSTEM_BET_COMBINATION_8_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_8_LABEL',
	SYSTEM_BET_COMBINATION_9_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_9_LABEL',
	SYSTEM_BET_COMBINATION_10_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_10_LABEL',
	SYSTEM_BET_COMBINATION_11_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_11_LABEL',
	SYSTEM_BET_COMBINATION_12_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_12_LABEL',
	SYSTEM_BET_COMBINATION_13_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_13_LABEL',
	SYSTEM_BET_COMBINATION_14_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_14_LABEL',
	SYSTEM_BET_COMBINATION_15_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_15_LABEL',
	SYSTEM_BET_COMBINATION_16_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_16_LABEL',
	SYSTEM_BET_COMBINATION_17_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_17_LABEL',
	SYSTEM_BET_COMBINATION_18_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_18_LABEL',
	SYSTEM_BET_COMBINATION_19_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_19_LABEL',
	SYSTEM_BET_COMBINATION_20_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_20_LABEL'
}
export const SYSTEM_BET_COMBINATIONS_TEXT_KEYS = [...Array(20).keys()].map((_, index: number) => {
	return `SPORTSBOOK_BETSLIP_SYSTEM_BET_COMBINATION_${index}_LABEL`;
});

export default BetTextKeys;
